import DaoBase from "./base";
import MD5 from "md5";
import {errors, rd} from "../../vars/rd";
import {$shutils} from "../../libs/snnh/snnh";
import DaoCategory from "./category";
import {jsi} from "../../index";
import {proxyBy, stringEncrypt, stringToHex} from "../func";

class DaoUser extends DaoBase {
    id;
    mac;
    end;
    shopid;
    bizid;
    groupid;
    bizname;
    shopname;
    serviceid;
    business;
    profile_img;
    mobile;
    zipcode;
    address;
    address_detail;

    payment_type = '정기';
    payment_name = '신탁 이용권';

    constructor(json=null) {
        super(json);
    }

    get milliseconds() {
        return $shutils.toDate(this.end).getTime();
    }

    /**
     * @returns {string|null}
     */
    get bizName() {
        try {
            return $shutils.base64Decode(this.bizname);
        } catch (e) {
            return this.bizname;
        }
    }

    get shopName() {
        try {
            return $shutils.base64Decode(this.shopname);
        } catch (e) {
            return this.shopname;
        }
    }

    /**
     *
     * @returns {DaoCategory} category
     */
    get shopBusiness() {
        let category = new DaoCategory({proname: '-'});
        (rd.category.business || []).forEach(
            /** @param business {DaoCategory} */
            business => {
                if(business.proid === this.business) category = business;
            }
        );
        return category;
    }

    get shopBusinessName() {
        return this.shopBusiness.proname;
    }

    get shopBusinessExists() {
        return !!this.shopBusiness.proid;
    }

    get shopImage() {
        return proxyBy(this.profile_img || rd.avatar_empty);
    }

    get shopAddress() {
        const address = [];
        if(this.zipcode) address.push(`[${this.zipcode}]`);
        if(this.address) address.push(this.address);
        if(this.address_detail) address.push(this.address_detail);
        return address.join(' ');
    }

    get isPeriod() {
        return this.milliseconds >= jsi.jsi_milliseconds();
    }

    get isValid() {
        return this.id && this.groupid && this.serviceid && this.isPeriod;
    }

    setUser(json) {
        try {
            this.serialize(json);
        } catch (e) {
            errors(e);
        }
    }

    /**
     *
     * @param destination
     * @returns {string}
     */
    websiteParameters(destination) {
        const iv = MD5(this.mac.split('').reverse().join('')).substr(0, 16);
        const serviceid = $shutils.pad(this.serviceid, 10, ' ');
        const serviceid_hex = stringToHex(serviceid);
        const txt = JSON.stringify({
            "id": this.id,
            "bizid": this.bizid,
            "groupid": this.groupid,
            "shopid": this.shopid,
            "serviceid": this.serviceid,
            "millisecond": jsi.jsi_milliseconds(),
            destination
        });
        const txt_crypted = stringEncrypt(JSON.stringify(txt), this.mac, iv);
        return `${txt_crypted}${serviceid_hex}${$shutils.pad(serviceid_hex.length, 3, 0)}${iv}`;
    }
}

export default DaoUser;


// WEBPACK FOOTER //
// ./src/modules/dao/user.js